<template>
  <div id="about-alarm" :class="theme">
      <h1>{{ $t('alarm.how') }}</h1>
      <p>{{ $t('alarm.way') }}</p>
      <div class="mb60">
          <img class="start" v-if='play1 === false' src="@/assets/预警播放1.png" alt="" @click="play1 = true">
          <img class="gif" v-else src="@/assets/预警动画-交易对.gif" alt="" @click="play1 = false">
      </div>
      <!-- <h1>如何添加指数预警？</h1>
      <p>登录状态下，进入任一指数页面，点击右上角预警按钮，即可添加指数预警。</p>
      <div>
          <img v-if='play2 === false' src="@/assets/预警播放2.png" alt="" @click="play2 = true">
          <img v-else src="@/assets/预警动画-指数.gif" alt="" @click="play2 = false">
      </div> -->
      <!-- <cav-gif :imgUrl="imgUrl" /> -->
  </div>
</template>

<script>
// const imgUrl = require('../../assets/预警动画-指数.gif') 
import CavGif from '@/components/CavGif.vue'
export default {
    name: 'AboutAlarm',
    data() {
        return {
            theme: 'day',
            play1: false,
            play2: false,
            // imgUrl: imgUrl
        }
    },
    components: {
        // CavGif,
    },
    mounted(){
        this.theme = this.$route.query.theme ? this.$route.query.theme : 'day';
    },

    methods: {

    }
}
</script>

<style lang='less'>
#about-alarm {
    height: 1960px;
	width: 100%;
    position: relative;
    background: #ffffff;
    font-family: PingFang SC;
    color: #33333A;
    text-align: left;
    padding: 60px 50px;
    h1 {
        font-size: 32px;
        font-weight: 700;
        line-height: 34px;
        margin-bottom: 20px;
    }
    p {
        font-size: 30px;
        font-weight: 500;
        line-height: 45px;
        margin-bottom: 30px;
    }
    .mb60 {
        margin-bottom: 60px;
    }
    img {
        width: 650px;
        &.start {
            height: 700px;
        }
        &.gif {
            height: 1300px;
        }
    }
}
</style>